import type { C1_ButtonOrientation } from "../types/C1_EloTypes";

/** Upright content uses the rotated area's dimensions, centered on the same key. */
export function buttonContentBox(x: number, y: number, width: number, height: number, orientation: C1_ButtonOrientation) {
  const rotated = orientation === "vertical";
  const centerX = x + width / 2;
  const centerY = y + height / 2;
  const contentWidth = rotated ? height : width;
  const contentHeight = rotated ? width : height;
  return {
    x: centerX - contentWidth / 2,
    y: centerY - contentHeight / 2,
    width: contentWidth,
    height: contentHeight,
    transform: rotated ? `rotate(90 ${centerX} ${centerY})` : undefined,
  };
}
